<template>
  <b-card>
    <b-card-header>
      <i class="icon-menu mr-1"></i>Device Detail
    </b-card-header>
    <Device :id="$route.params.id"/>
    <h5>Registered User List</h5>
    <Users :hasDevice="$route.params.id"/>
    <h5>Logs</h5>
    <Logs :deviceId="$route.params.id"/>       
    <template slot="footer">
      <b-button @click="goBack">Back</b-button>
    </template>
  </b-card>
</template>

<script>
import Users from '../users/Users'
import Device from '../devices/Device'
import Logs from '../logs/Logs'

export default {
  name: 'DeviceDetail',
  components: {
      Users,
      Device,
      Logs,
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
